import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AnnouncementsView } from "@/features/academy/components/community/announcements-view";

// F3-C: organization-level announcements (list + composer for admins/teachers).
export const academyAnnouncementsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/academy/announcements",
  component: AnnouncementsView,
});
